import React from "react";
import Loader from "@liveramp/motif/core/Loader";

export default function SmallDemo() {
  return <Loader size="small" />;
}
